import VueLoadImage from "vue-load-image";
import { thumbnail } from "../../../functions/thumbnail";

export default {
  props: {
    file: Object,
    overwriteImg: String,
    small: Boolean,
  },
  computed: {
    createSrc() {
      const src = this.overwriteImg
        ? this.overwriteImg
        : this.thumb(this.file, true);

      return src;
    },
  },
  methods: {
    thumb(item, big = false) {
      return thumbnail(item, this.small);
    },
  },
  components: {
    "vue-load-image": VueLoadImage,
  },
};
